<script>
import { mapState, mapActions } from 'vuex'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import { VueGoodTable } from 'vue-good-table'
import { SweetModal } from 'sweet-modal-vue'
import VuePdfApp from 'vue-pdf-app'
import { debounce } from 'vue-debounce'
import { id } from 'vuejs-datepicker/dist/locale'
import vSelect from 'vue-select'
import axios from 'axios'
import PaginationCustom from '@/components/table/Pagination.vue'
import ProsesPermohonan from '@/components/sicantik/ProsesPermohonan.vue'

const baseURL = process.env.VUE_APP_BASE_URL

export default {
   name: 'SicantikPermohonan',
   components: {
      BCardCode,
      VueGoodTable,
      PaginationCustom,
      SweetModal,
      VuePdfApp,
      ProsesPermohonan,
      vSelect,
   },
   data() {
      return {
         pdf: '',
         loadingPdf: false,
         loading: true,
         filterDateLang: id,
         jenisIzinList: [],
         options: {
            jenis: [
               { value: null, text: '-' },
               { value: 'Baru', text: 'Baru' },
               { value: 'Perpanjangan', text: 'Perpanjangan' },
            ],
         },
         serverParams: {
            columnFilters: {},
            sort: {
               field: '',
               type: '',
            },
            search: '',
            page: 1,
            perPage: 10,
            filter: {
               tanggal_awal: null,
               tanggal_akhir: null,
               id_jenis_izin: null,
            },
         },
         pageLength: 10,
         pageOptions: ['10', '25', '50', '100'],
         searchTerm: '',
         isFilterOpen: false,
         columns: [
            {
               label: 'No Permohonan',
               field: 'no_permohonan',
               sortable: false,
               thClass: 'text-center align-middle',
            },
            {
               label: 'Pemohon',
               field: 'nama_pemohon',
               sortable: false,
               thClass: 'text-center align-middle',
            },
            {
               label: 'Jenis Izin',
               field: 'jenis_izin',
               sortable: false,
               thClass: 'text-center align-middle',
            },
            {
               label: 'Proses',
               field: 'proses',
               sortable: false,
               thClass: 'text-center align-middle',
            },
            {
               label: 'Tgl Ditetapkan',
               field: 'tgl_ditetapkan',
               sortable: false,
               thClass: 'text-center align-middle',
            },
            {
               label: 'Action',
               field: 'action',
               sortable: false,
               thClass: 'text-center align-middle',
            },
         ],
      }
   },
   computed: {
      ...mapState({
         myData: state => state.SicantikPermohonan.items,
         myProses: state => state.SicantikPermohonan.itemsProses,
         myCount: state => state.SicantikPermohonan.countAll,
      }),
      optionsJenisIzin() {
         return [{ value: null, text: '-' }, ...this.jenisIzinList.map(item => ({ value: item.id, text: item.nama || item.name }))]
      },
      tanggalPenetapan() {
         return tanggal => {
            let value = ''

            if (tanggal !== '0000-00-00') {
               value = this.$moment(tanggal).format('DD MMMM YYYY')
            } else {
               value = '-'
            }

            return value
         }
      },
   },
   watch: {
      loadingPdf(val) {
         if (val) {
            this.$swal({ text: 'Loading', allowOutsideClick: false })
            this.$swal.showLoading()
         } else {
            this.$swal.close()
         }
      },
   },
   mounted() {
      this.getJenisIzin()
      this.loadItems()
   },
   methods: {
      ...mapActions({
         getData: 'SicantikPermohonan/getData',
         getDataProses: 'SicantikPermohonan/getProses',
         cetakIzin: 'SicantikPermohonan/cetakIzin',
         cetakPermohonan: 'SicantikPermohonan/cetakPermohonan',
      }),
      onProsesList(idPermohonan) {
         this.getDataProses(idPermohonan).then(() => {
            this.$bvModal.show('modal-proses')
         }, () => {

         })
      },
      onCetakIzin(nib) {
         this.loadingPdf = true
         this.cetakIzin(nib).then(res => {
            const blob = new Blob([res.data])
            this.pdf = URL.createObjectURL(blob)
            // URL.revokeObjectURL(objectURL)
            this.$refs.modalPdf.open()
            this.loadingPdf = false
         }, () => {
            this.loadingPdf = false
         })
      },
      onCetak() {
         if (!this.isFilterOpen) {
            this.$toast.error('Aktifkan filter untuk mencetak PDF')
            return
         }
         this.loadingPdf = true
         const params = {}
         const tglAwal = this.formatDate(this.serverParams.filter.tanggal_awal)
         const tglAkhir = this.formatDate(this.serverParams.filter.tanggal_akhir)
         if (tglAwal) params.tanggal_awal = tglAwal
         if (tglAkhir) params.tanggal_akhir = tglAkhir
         if (this.serverParams.filter.id_jenis_izin !== null) {
            params.id_jenis_izin = this.serverParams.filter.id_jenis_izin
         }
         if (this.searchTerm) {
            params.search = this.searchTerm
         }
         this.cetakPermohonan(params).then(res => {
            const blob = new Blob([res.data])
            this.pdf = URL.createObjectURL(blob)
            this.$refs.modalPdf.open()
            this.loadingPdf = false
         }, () => {
            this.loadingPdf = false
         })
      },
      formatDate(date) {
         if (!date) return null
         const d = new Date(date)
         const year = d.getFullYear()
         const month = String(d.getMonth() + 1).padStart(2, '0')
         const day = String(d.getDate()).padStart(2, '0')
         return `${year}-${month}-${day}`
      },
      getJenisIzin() {
         axios.get(`${baseURL}api/list/sicantik/jenis-izin`).then(res => {
            const data = Array.isArray(res.data) ? res.data : res.data.data || []
            this.jenisIzinList = data
         })
      },
      onFilter() {
         this.serverParams.page = 1
         setTimeout(() => {
            this.loadItems()
         }, 100)
      },

      // VUE GOOD TABLE
      loadItems() {
         this.loading = true
         this.getData(this.serverParams)
      },
      updateParams(newProps) {
         // eslint-disable-next-line prefer-object-spread
         this.serverParams = Object.assign({}, this.serverParams, newProps)
      },
      onPageChangePagination(page) {
         this.updateParams({ page })
         this.loadItems()
      },
      onPerPageChangePagination(perPage) {
         this.updateParams({ perPage, page: 1 })
         this.loadItems()
      },
      onColumnFilter(params) {
         this.updateParams({ ...params, page: 1 })
         this.loadItems()
      },
      onSearch: debounce(function search(params) {
         this.serverParams.search = params
         this.serverParams.page = 1
         this.loadItems()
      }, 500),
      onShownCollapse() {
         this.isFilterOpen = true
         this.serverParams.page = 1
         this.serverParams.filter.tanggal_awal = new Date(new Date().getFullYear(), 0, 1)
         this.serverParams.filter.tanggal_akhir = new Date()
         this.serverParams.filter.id_jenis_izin = null
         this.loadItems()
      },
      onHiddenCollapse() {
         this.isFilterOpen = false
         this.serverParams.page = 1
         this.serverParams.filter.tanggal_awal = null
         this.serverParams.filter.tanggal_akhir = null
         this.serverParams.filter.id_jenis_izin = null
         this.loadItems()
      },
   },
}
</script>

<template>
   <div>
      <b-card-code title="Data Permohonan SICANTIK">
         <!-- search input -->
         <b-row>
            <!-- TOOLBAR -->
            <b-col cols="12" md="6">
               <b-form @submit.stop.prevent>
                  <div class="d-flex align-items-center justify-content-end">
                     <b-form-input
                        v-model="searchTerm"
                        class="d-inline-block mb-1"
                        placeholder="Search..."
                        autocomplete="off"
                        type="text"
                        aria-label="Search"
                        @input="onSearch"
                     />
                  </div>
               </b-form>
            </b-col>
            <b-col cols="12" md="6">
               <div class="d-flex justify-content-end">
                  <b-button-group class="mb-1">
                     <b-button
                        v-b-tooltip.hover.top="'Filter'"
                        v-b-toggle.collapse-filter
                        variant="outline-secondary"
                        size="sm"
                     >
                        <feather-icon icon="FilterIcon" />
                     </b-button>
                     <b-button
                        v-b-tooltip.hover.top="'Cetak PDF'"
                        variant="outline-secondary"
                        size="sm"
                        @click="onCetak()"
                     >
                        <feather-icon icon="FileTextIcon" />
                     </b-button>
                     <b-button variant="outline-secondary" size="sm" @click="loadItems()">
                        <feather-icon icon="RefreshCwIcon" />
                     </b-button>
                     <b-dropdown variant="outline-secondary" right text="Menu" size="sm">
                        <b-dropdown-item @click="loadItems()">
                           Refresh
                        </b-dropdown-item>
                        <b-dropdown-item @click="onCetak()">
                           Cetak PDF
                        </b-dropdown-item>
                     </b-dropdown>
                  </b-button-group>
               </div>
            </b-col>

            <!-- FILTER -->
            <b-col cols="12">
               <b-collapse id="collapse-filter" class="mt-2" @shown="onShownCollapse" @hidden="onHiddenCollapse">
                  <b-card class="border">
                     <b-row>
                        <b-col md="4">
                           <b-form-group label="Tanggal Terbit Awal" label-for="tanggal-awal">
                              <datepicker
                                 v-model="serverParams.filter.tanggal_awal"
                                 input-class="datepicker-here form-control"
                                 minimum-view="date"
                                 maximum-view="year"
                                 format="dd MMMM yyyy"
                                 :language="filterDateLang"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                        <b-col md="4">
                           <b-form-group label="Tanggal Terbit Akhir" label-for="tanggal-akhir">
                              <datepicker
                                 v-model="serverParams.filter.tanggal_akhir"
                                 input-class="datepicker-here form-control"
                                 minimum-view="date"
                                 maximum-view="year"
                                 format="dd MMMM yyyy"
                                 :language="filterDateLang"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                        <b-col md="4">
                           <b-form-group label="Jenis Izin" label-for="jenis-izin">
                              <v-select
                                 id="jenis-izin"
                                 v-model="serverParams.filter.id_jenis_izin"
                                 :options="optionsJenisIzin"
                                 :reduce="opt => opt.value"
                                 label="text"
                                 placeholder="Pilih Jenis Izin..."
                                 :clearable="true"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                     </b-row>
                  </b-card>
               </b-collapse>
            </b-col>
            <!-- FILTER -->
         </b-row>

         <!-- table -->
         <vue-good-table
            ref="goodTable"
            mode="remote"
            :columns="columns"
            :rows="myData"
            :total-rows="myCount"
            :is-loading.sync="loading"
            :line-numbers="true"
            :pagination-options="{
               enabled: true,
               mode: 'pages',
            }"
            :search-options="{
               enabled: true,
               externalQuery: searchTerm,
            }"
            @on-column-filter="onColumnFilter"
            @on-search="onSearch"
         >
            <template slot="table-row" slot-scope="props">
               <!-- Column: Name -->
               <span v-if="props.column.field == 'no_permohonan'">
                  <b>{{ (props.row.no_permohonan) }}</b>
                  <br>
                  <small>Tanggal : {{ props.row.tgl_pengajuan | moment("DD-MM-YYYY") }}</small>
               </span>

               <span v-if="props.column.field == 'nama_pemohon'">
                  <b>{{ props.row.nama_pemohon }}</b>
               </span>

               <span v-if="props.column.field == 'jenis_izin'">{{ (props.row.nama_izin) }}</span>

               <span v-else-if="props.column.field == 'proses'">{{ (props.row.nama_proses) }}</span>

               <span
                  v-else-if="props.column.field == 'tgl_ditetapkan'"
               >{{ tanggalPenetapan(props.row.tgl_selesai) }}</span>

               <span v-if="props.column.field == 'action'">
                  <b-button
                     size="sm"
                     block
                     variant="outline-dark"
                     @click="onProsesList(props.row.id_permohonan)"
                  >
                     <feather-icon icon="ListIcon" class="mr-50" />
                     <small>List Proses</small>
                  </b-button>
                  <b-button
                     v-if="props.row.s3_path"
                     size="sm"
                     block
                     variant="primary"
                     @click="onCetakIzin(props.row.id_permohonan)"
                  >
                     <feather-icon icon="FileTextIcon" class="mr-50" />
                     <small>Cetak Izin</small>
                  </b-button>
               </span>
               <!-- Column: Common -->
               <!-- <span v-else>{{ props.formattedRow[props.column.field] }}</span> -->
               <!-- <span v-else>{{ props.formattedRow[props.column.field] }}</span> -->
            </template>

            <!-- pagination -->
            <template slot="pagination-bottom" slot-scope="props">
               <pagination-custom
                  :total="props.total"
                  :page-length="pageLength"
                  :page-options="pageOptions"
                  :page="serverParams.page"
                  :page-changed="props.pageChanged"
                  :per-page-changed="props.perPageChanged"
                  @update:page="onPageChangePagination"
                  @update:perpage="onPerPageChangePagination"
               />
            </template>
         </vue-good-table>
      </b-card-code>

      <b-modal
         id="modal-proses"
         scrollable
         size="md"
         centered
         hide-footer
         title="Proses Permohonan"
      >
         <div style="height: 70vh;">
            <ProsesPermohonan />
         </div>
      </b-modal>

      <sweet-modal ref="modalPdf" modal-theme="light" overlay-theme="dark" width="80%">
         <!-- <pdf :src="pdf" /> -->
         <div style="height: 70vh;">
            <vue-pdf-app :pdf="pdf" />
         </div>
      </sweet-modal>
   </div>
</template>

<style scoped>
.borderless > tr > td {
   border: none;
   padding: 0em;
}

.borderless > tr > td {
   border: none;
   padding: 0em;
}
table > tbody > tr > td > span > hr {
   margin-top: 0rem;
   margin-bottom: 0rem;
}

.nowrap {
   white-space: nowrap;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.hidden_header {
   display: none;
}
</style>
